<template>
  <material-card
    icon="mdi-view-list"
    icon-small
    title="Cumuluslog Darasources"
    color="accent"
  >
    <v-container class="py-0">
      <v-row>
        <v-col
          v-for="(selector, i) in selectors"
          :key="`selector-${i}`"
          cols="12"
          md="6"
          lg="4"
        >
          <data-selector
            :field-name="selector.name"
            :source-type="selector.type"
          />
        </v-col>
      </v-row>
    </v-container>
  </material-card>
</template>

<script>
  export default {
    name: 'DataSources',
    data () {
      return {
        selectors: [
          { name: 'plane_type', type: 'planeTypes' },
          { name: 'role', type: 'roles' },
          { name: 'airport', type: 'airports' },
          { name: 'operator', type: 'operators' },
          { name: 'permission', type: 'permissions' },
          { name: 'document_type', type: 'documentTypes' },
          { name: 'plane_category', type: 'planeCategories' },
          { name: 'plane_permission', type: 'planePermissions' },
          { name: 'takeoff_type', type: 'planePermissions' },
          { name: 'transaction_type', type: 'transactionTypes' },
          { name: 'task', type: 'tasks' },
          { name: 'winch_operation_types', type: 'winchOperationTypes' },
        ],
      }
    },
  }
</script>
